import { render, staticRenderFns } from "./TemplateContentDetailWidget.vue?vue&type=template&id=7ed89aad&scoped=true&"
import script from "./TemplateContentDetailWidget.vue?vue&type=script&lang=ts&"
export * from "./TemplateContentDetailWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateContentDetailWidget.vue?vue&type=style&index=0&id=7ed89aad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed89aad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
